// 界面缩放刷新
// $(window).resize(function () {
//     location.reload();
// })
var t = window.devicePixelRatio   // 获取下载的缩放 125% -> 1.25    150% -> 1.5
var Fwidth = window.screen.width*t // 分辨率大小
console.log(t,'缩放的大小');
console.log(window.screen.width*t,'分辨率大小');
window.onload = function(e){
    var e = e || event
    if (!!window.ActiveXObject || "ActiveXObject" in window) { 
        if (t != 1) {  
            // 如果在笔记本中用IE浏览器打开 则弹出提示
            alert('您的设备对显示进行放大导致页面显示不完全,请调整后打开或用其他浏览器')
        }
    } else {
        if(Fwidth < 3000){
            if(t < 2){
                document.getElementsByTagName('body')[0].style.zoom = 1/t;
            }else if (t >= 2){
                document.getElementsByTagName('body')[0].style.zoom = 0.7;
            }
        }
    }
    e.stopPropagation()
}
// ui-dialog ui-dialog-shadow ui-widget ui-widget-content ui-front ui-draggable ui-dialog-maximize


// WEBPACK FOOTER //
// app/lib/Adaptation.js